import { Trans, useTranslation } from 'react-i18next';
import { useOpenLiveChat } from '@hub/hooks';
import { useMediaQuery, useTheme } from '@mui/material';
import { Button, Stack, Typography } from '@monorepo/nova-ui';
import { useStore } from '../../helpers/use-store';

export const NotReceivedMail = ({
  header,
  message,
  handleSendMailClick,
  isLoading,
}: {
  header: string;
  message: string;
  handleSendMailClick: () => Promise<boolean>;
  isLoading: boolean;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation(['mailConfirmationNova']);
  const openLiveChat = useOpenLiveChat({ flow: 'not-received-mail' });

  const {
    dataStore: { userStore },
  } = useStore();

  return (
    <Stack direction={'column'} textAlign={'center'} gap={6}>
      <Typography variant={'h3'} lineHeight={1}>
        {header}
      </Typography>
      <Typography textAlign="center">{message}</Typography>
      <Typography
        bgcolor={theme.palette.background.contrast}
        variant={'h6'}
        borderRadius={24}
        lineHeight={1}
        fontWeight={theme.typography.fontWeightRegular}
        color={theme.palette.secondaryInvert.main}
        padding={theme.spacing(2)}
      >
        {userStore.currentUser.email}
      </Typography>
      <Typography textAlign="center">
        <Trans
          ns="mailConfirmationNova"
          i18nKey="wrong_email_contact"
          components={{
            a0: (
              <Typography
                display={'inline'}
                color={theme.palette.blue.main}
                sx={{
                  cursor: 'pointer',
                }}
                onClick={openLiveChat}
                children={undefined}
              />
            ),
          }}
        />
      </Typography>
      <Stack direction={isMobile ? 'column-reverse' : 'row'} gap={6}>
        <Button
          sx={{ width: '100%' }}
          size={'xl'}
          variant={'outlined'}
          onClick={openLiveChat}
        >
          <Typography
            variant={'subtitle2'}
            fontSize={theme.typography.pxToRem(16)}
            color="inherit"
          >
            {t('mailConfirmationNova:contact_support')}
          </Typography>
        </Button>
        <Button
          sx={{ width: '100%' }}
          size={'xl'}
          variant={'primary'}
          onClick={handleSendMailClick}
          disabled={isLoading}
        >
          <Typography
            variant={'subtitle2'}
            fontSize={theme.typography.pxToRem(16)}
            color="inherit"
          >
            {t('mailConfirmationNova:send_code_cta')}
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
};
